// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"3159":"ce6c4921","4945":"2a7e8315","8170":"db72a35a"}[chunkId] + ".js";
};